export type SortDirection = "ascending" | "descending" | "none";
